<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_task_grouping"></i>{{dataset[currentVal].label}}
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown">
        <el-dropdown-item
        v-for="item in dataset"
        :key="item.value"
        :command="item.value"
        >
        <toolTip :title="item.label"><span>{{item.label}}</span></toolTip>
          <i class="icon iconfont iconicon_selected_more_task" v-show="currentVal === item.value"></i>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  props: ['value'],
  data() {
    return {
      dataset: [{
        label: '按照时间排列',
        value: 0
      }, {
        label: '未读通知在前',
        value: 1
      }],
    }
  },
  computed: {
    currentVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleCommand(val) {
      this.currentVal = val
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss">
.filter-status {
}
</style>
